'use strict';
module.exports = require('./ScrollPanel.vue');